import { composeClassNames } from "@faedev/editor-utils";
import videojs from "@mux/videojs-kit";
import "@mux/videojs-kit/dist/index.css";
import { useEffect, useRef, useState } from "react";
import constants from "src/constants";
import { sVideoJS } from "src/styles/sVideoJS.module.scss";

type Props = {
  videoSource: string;
  className?: (string | string) | null | undefined;
  fullWidth?: boolean | null | undefined;
};

function Mux({ className, videoSource, fullWidth }: Props) {
  const videoRef = useRef(null);
  const playerRef = useRef(null);

  const [playbackId, setPlaybackId] = useState("");
  const [JWT, setJWT] = useState("");

  useEffect(() => {
    (async () => {
      setPlaybackId(videoSource);

      if (playbackId) {
        const response = await fetch(
          constants.Paths.apiUrl + `/get-jwt/` + playbackId
        );

        const JWTstring = await response.text();
        setJWT(JWTstring);
      }
    })();
  }, [playbackId, videoSource]);

  useEffect(() => {
    if (videoRef.current && JWT) {
      const initTime = new Date();
      playerRef.current = videojs(videoRef.current, {
        sources: [
          {
            src: playbackId + `?token=` + JWT,
            type: "video/mux",
          },
        ],
        plugins: {
          mux: {
            timelineHoverPreviews: true,
            debug: true,
            data: {
              env_key: "4ivdiiqk83kjf822pgnqc4d43",
              player_name: "videojs mux-kit player",
              player_init_time: initTime,
            },
          },
        },
      });
    }
  }, [JWT, playbackId]);

  return (
    <div
      className={composeClassNames([
        sVideoJS,
        className,
        fullWidth && "full-width",
        "video-js-wrapper",
      ])}
    >
      <video controls ref={videoRef} className="video-js" />
    </div>
  );
}

export default Mux;
